import type { CommercialTerm } from '@/pages/quotation-design/types';
import SectionTitle from './SectionTitle';

export default function CommercialTerms({ terms }: { terms: CommercialTerm[] }) {
  return (
    <div className="px-6 md:px-9 mt-8">
      <SectionTitle>Commercial Terms</SectionTitle>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
        {terms.map((t) => (
          <div key={t.label} className="flex items-start gap-4">
            <span className="w-32 shrink-0 text-xs text-ink-400">{t.label}</span>
            <span className="text-sm font-medium text-ink-700 leading-snug">{t.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}